<template>
  <v-footer id="core-footer" absolute height="50">
    <div class="footer-items">
      <span v-for="link in links" :key="link.name">
        <a :href="link.Link" class="tertiary--text footer-links">
          {{ link.name }}
        </a>
      </span>
    </div>
    <v-spacer />
    <v-btn text @click="privacyDialog = true">
      {{ $t("globals.privacy_policy") }}
    </v-btn>
    |
    <v-btn text @click="termsConditionsDialog = true">
      {{ $t("globals.terms_conditions") }}
    </v-btn>
    <v-spacer />
    <span class="font-weight-light copyright">
      &copy;
      {{ new Date().getFullYear() }}
      {{ $t("components.core.footer.the_pbas_group") }}
    </span>
    <v-dialog
      v-model="termsConditionsDialog"
      max-width="700"
      persistent
      scrollable
    >
      <material-card
        :title="$t('globals.terms_conditions').toUpperCase()"
        :color="$vuetify.theme.themes.light.secondary"
        icon="rule"
      >
        <v-card-text>
          <p v-html="terms"></p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="termsConditionsDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog v-model="privacyDialog" max-width="700" persistent scrollable>
      <material-card
        :title="$t('globals.privacy_policy').toUpperCase()"
        :color="$vuetify.theme.themes.light.secondary"
        icon="policy"
      >
        <v-card-text>
          <p v-html="policy"></p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="privacyDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </v-footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    links: [
      //{ name: 'Blog', Link: 'https://blog.creative-tim.com' }
    ],
    termsConditionsDialog: false,
    privacyDialog: false,
    policy: `<html>

<head>
<meta http-equiv=Content-Type content="text/html; charset=utf-8">
<meta name=Generator content="Microsoft Word 15 (filtered)">
<style>
<!--
 /* Font Definitions */
 @font-face
	{font-family:Helvetica;
	panose-1:2 11 6 4 2 2 2 2 2 4;}
@font-face
	{font-family:Wingdings;
	panose-1:5 0 0 0 0 0 0 0 0 0;}
@font-face
	{font-family:"Cambria Math";
	panose-1:2 4 5 3 5 4 6 3 2 4;}
@font-face
	{font-family:Calibri;
	panose-1:2 15 5 2 2 2 4 3 2 4;}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{margin-top:0in;
	margin-right:0in;
	margin-bottom:8.0pt;
	margin-left:0in;
	line-height:107%;
	font-size:11.0pt;
	font-family:"Calibri",sans-serif;}
p.MsoListParagraph, li.MsoListParagraph, div.MsoListParagraph
	{margin-top:0in;
	margin-right:0in;
	margin-bottom:8.0pt;
	margin-left:.5in;
	line-height:107%;
	font-size:11.0pt;
	font-family:"Calibri",sans-serif;}
p.MsoListParagraphCxSpFirst, li.MsoListParagraphCxSpFirst, div.MsoListParagraphCxSpFirst
	{margin-top:0in;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:.5in;
	line-height:107%;
	font-size:11.0pt;
	font-family:"Calibri",sans-serif;}
p.MsoListParagraphCxSpMiddle, li.MsoListParagraphCxSpMiddle, div.MsoListParagraphCxSpMiddle
	{margin-top:0in;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:.5in;
	line-height:107%;
	font-size:11.0pt;
	font-family:"Calibri",sans-serif;}
p.MsoListParagraphCxSpLast, li.MsoListParagraphCxSpLast, div.MsoListParagraphCxSpLast
	{margin-top:0in;
	margin-right:0in;
	margin-bottom:8.0pt;
	margin-left:.5in;
	line-height:107%;
	font-size:11.0pt;
	font-family:"Calibri",sans-serif;}
.MsoChpDefault
	{font-family:"Calibri",sans-serif;}
.MsoPapDefault
	{margin-bottom:8.0pt;
	line-height:107%;}
@page WordSection1
	{size:8.5in 11.0in;
	margin:1.0in 1.0in 1.0in 1.0in;}
div.WordSection1
	{page:WordSection1;}
 /* List Definitions */
 ol
	{margin-bottom:0in;}
ul
	{margin-bottom:0in;}
-->
</style>

</head>

<body lang=EN-US link=blue vlink="#954F72" style='word-wrap:break-word'>

<div class=WordSection1>


<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>PBAS Privacy Policy</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>Prudent Benefits Administration Services Inc., Benchmark
Decisions Ltd., and Student Benefits Administrators Inc. (hereinafter referred
to collectively as “PBAS”, for ease of reference).</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>PBAS Data</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>Is data that is entrusted to PBAS for the purpose of
administering the business on behalf of PBAS clients and their plan
participants, including financial records, employee/participant files or any
other data deemed as private and confidential. This Privacy Policy supplements
PBAS’s&nbsp;professional and ethical obligations of the personal information
entrusted to PBAS from our clients, and from PBAS employees.</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>Personal Information</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>Personal Information is any factual or subjective information,
recorded or not, about an identifiable individual.&nbsp; In general, Personal
Information, does not include business contact information, including your
name, title, and business telephone number.&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>Chief Privacy Officer</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>The person at PBAS who is responsible for overseeing that
privacy practices are carried out to ensure overall compliance with federal and
provincial privacy legislation. This includes ensuring that all staff are
trained on privacy best practices and carrying out any disclosure requirements
under the applicable privacy legislation including privacy breaches.</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>Introduction</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>PBAS has always recognized and respected the privacy and
confidentiality of Personal Information collected in the course of its daily
business activities.&nbsp; As a further commitment, PBAS has created this
Privacy Policy, which is an embodiment of PBAS’s adherence to the principles
outlined in the Personal Information Protection and Electronic Documents Act
(“PIPEDA”) and applies to all PBAS operations.&nbsp; A copy of PIPEDA is
available at&nbsp;</span><a href="http://www.priv.gc.ca/" target="_blank"><span
style='font-size:10.5pt;font-family:"Helvetica",sans-serif;color:#204291'>www.priv.gc.ca</span></a><span
style='font-size:10.5pt;font-family:"Helvetica",sans-serif;color:#444444'>.
PBAS complies with all applicable federal and provincial privacy legislation.
In addition, PBAS has a documented process for reporting a breach incident for
information in its possession or custody, including information that has been
transferred to a third party for processing.&nbsp; This approach is consistent
with the General Data Protection Regulation (“GDPR”). A copy of GDPR is
available at&nbsp;</span><a href="http://www.gdpr.eu/" target="_blank"><span
style='font-size:10.5pt;font-family:"Helvetica",sans-serif;color:#1155CC'>www.gdpr.eu</span></a><span
style='font-size:10.5pt;font-family:"Helvetica",sans-serif;color:#444444'>.</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>The Office of the Privacy Commissioner of Canada (“OPC”) defines
a “breach of security safeguards” as:</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><i><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>the loss of, unauthorized access to or unauthorized disclosure
of personal information resulting from a breach of an organization’s security
safeguards or from a failure to establish those safeguards.</span></i></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>According to the OPC, a privacy breach is:</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><i><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>the loss of, unauthorized access to, or disclosure of, personal
information. Breaches can happen when personal information is stolen, lost or
mistakenly shared.</span></i></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>Only breaches including personal information are in scope for
PIPEDA, based on a test for a “real risk of significant harm.”</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><i><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>The law defines “significant harm” to include bodily harm,
humiliation, damage to reputation or relationships, loss of employment,
business or professional opportunities, financial loss, identity theft,
negative effects on the credit record and damage to or loss of property.</span></i></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>PIPEDA’s Ten Fair Information Principles</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>The following ten principles of privacy are interrelated and are
based on fair information practices.&nbsp; They are intended to recognize an
individual’s right of privacy while balancing the need for an organization to
collect, use or disclose Personal Information for legitimate business purposes.</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>1) Accountability</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>PBAS is accountable for all Personal Information in its
possession or control, including any Personal Information transferred to third
parties.&nbsp; PBAS has established policies and procedures to comply with this
Privacy Policy. All staff are required to sign a Confidentiality Agreement as a
condition of their employment. Whenever PBAS engages the services of a third party
provider, a Confidentiality and Non-Dislcosure Agreement is executed to ensure
safeguards are in place to protect Personal Information. In addition to regular
audits and other compliance procedures, employee training is conducted
regularly to ensure that standards set by federal and provincial privacy
legislation are followed.</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>2) Identifying the Purposes of Collecting Personal Information</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>Unless additional purposes are identified to an individual
before or at the time of collection, PBAS will collect Personal Information
only for the following purposes.</span></p>

<p class=MsoListParagraphCxSpFirst style='margin-bottom:11.25pt;text-align:
justify;text-indent:-.25in;line-height:normal;background:white'><span
style='font-size:10.5pt;font-family:Symbol;color:#444444'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>compute and/or pay a benefit</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-bottom:11.25pt;text-align:
justify;text-indent:-.25in;line-height:normal;background:white'><span
style='font-size:10.5pt;font-family:Symbol;color:#444444'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>payroll purposes</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-bottom:11.25pt;text-align:
justify;text-indent:-.25in;line-height:normal;background:white'><span
style='font-size:10.5pt;font-family:Symbol;color:#444444'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>satisfy the reporting requirements of the provincial and federal
governments</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-bottom:11.25pt;text-align:
justify;text-indent:-.25in;line-height:normal;background:white'><span
style='font-size:10.5pt;font-family:Symbol;color:#444444'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>pay taxes and comply with civil and criminal law</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-bottom:11.25pt;text-align:
justify;text-indent:-.25in;line-height:normal;background:white'><span
style='font-size:10.5pt;font-family:Symbol;color:#444444'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>determine future operating costs</span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-bottom:11.25pt;text-align:
justify;text-indent:-.25in;line-height:normal;background:white'><span
style='font-size:10.5pt;font-family:Symbol;color:#444444'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>accommodate audits</span></p>

<p class=MsoListParagraphCxSpLast style='margin-bottom:11.25pt;text-align:justify;
text-indent:-.25in;line-height:normal;background:white'><span style='font-size:
10.5pt;font-family:Symbol;color:#444444'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>transfer applicable PBAS Data to a new or replacement benefit
plan</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>3) Obtaining Consent</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>PBAS will collect, use or disclose Personal Information only
with an individual’s knowledge and consent, except where required or permitted
by law. This is commonly acquired through the completion of a benefit enrolment
form.&nbsp; An individual can provide consent to the collection, use and
disclosure of Personal Information about them expressly, or through an
authorized representative.&nbsp; The latter would require written authorization
from the individual to release the Personal Information.&nbsp; For an
individual who is a minor, seriously ill, or mentally incapacitated, consent
may be obtained from a legal guardian, or person having power of attorney.&nbsp;
Subject to certain legal or contractual restrictions and reasonable notice, an
individual can withdraw consent at any time. PBAS will inform individuals of
the consequences of refusing or withdrawing consent when individuals seek to do
so.&nbsp; Refusing or withdrawing consent could precipitate the destruction of
an individual’s Personal Information and may, therefore, render ongoing
participation in a benefit plan impossible.&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>4) Limits for Collecting Personal Information</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>PBAS will limit the amount and type of Personal Information
collected.&nbsp; PBAS will collect Personal Information only for the identified
purposes or as otherwise permitted by law and, will only collect the
information about an individual primarily from the individual or, from external
sources if individuals have consented to such collection.</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>5) Limits for Using, Disclosing and Keeping Personal Information</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>PBAS will use or disclose Personal Information only for the
reasons it was collected, unless an individual provides consent to use or
disclose it for another reason. Under certain circumstances, PBAS may have a
legal duty or right to disclose Personal Information without consent.&nbsp;
PBAS will keep Personal Information only as long as necessary for the
identified purposes.</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>6) Keeping Personal Information Accurate</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>PBAS will keep the Personal Information in its possession or
control accurate, complete, current and relevant, based on the most recent
information available to PBAS. Individuals may challenge the accuracy and
completeness of Personal Information about them and have it amended as
appropriate. &nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>If an individual demonstrates that Personal Information is
inaccurate, incomplete, out-of-date or irrelevant, PBAS will revise or delete
the Personal Information and, disclose the revised Personal Information to any
third parties to whom wrong or outdated information was disclosed in order to
permit them to revise their records.&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>7) Safeguarding Personal Information&nbsp;</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>PBAS will protect Personal Information with safeguards
appropriate to the sensitivity of the information.</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>The use of encryption, firewalls, anti-virus programs and robust
authentication procedures, including updating passwords on a regular basis, are
some examples of the security controls in place.&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>Disaster Recovery (“DR”) tests are performed annually at a
remote DR location. As part of this test, all server based systems are
recovered and verified. Privacy protection is outlined in a contractual
agreement we enter into on an annual basis with the company that performs the
DR testing.&nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>8) Making Information About Policies and Procedures Available</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>PBAS will be transparent about the procedures used to manage
Personal Information. &nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>9) Providing Access to Personal Information</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>When requested to do so PBAS will advise an individual what
Personal Information is in its possession or control about the individual, what
it is being used for, and to whom it has been disclosed. PBAS will respond to
the request no later than thirty (30) days after receipt of the request.&nbsp;
This timeframe may be extended for a maximum of thirty (30) additional days,
if, for example, additional time is required to conduct consultations.&nbsp; If
that were to happen, PBAS would notify the individual in writing.&nbsp; In the
unlikely event that PBAS determines that there may be a cost to the individual
in granting such access, PBAS shall inform the individual of the costs
permitted by law prior to granting such access. &nbsp;</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>10) Handling Complaints and Questions</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>Complaints and inquiries should be directed, in writing, to the
Chief Privacy Officer at the following address:</span></p>

<p class=MsoNormal align=center style='margin-bottom:11.25pt;text-align:center;
line-height:normal;background:white'><b><span style='font-size:10.5pt;
font-family:"Helvetica",sans-serif;color:#444444'>PBAS</span></b><span
style='font-size:10.5pt;font-family:"Helvetica",sans-serif;color:#444444'><br>
110-61 International Blvd<br>
Toronto, Ontario M9W 6K4</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>All complaints will be investigated. If a complaint is found to
be justified, PBAS will take appropriate measures, including, if necessary,
amending policies and practices. If individuals are not satisfied with the way
PBAS has responded to their complaint or inquiry they may file a written
complaint with:</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;line-height:normal;background:
white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>Office of the Privacy Commissioner of Canada<br>
30 Victoria Street<br>
Gatineau, Quebec K1A 1H3</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><b><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>Changes to This Privacy Policy&nbsp;</span></b></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>In order to ensure that this Privacy Policy is kept up-to-date,
PBAS reserves the right to amend it from time to time. Notice of changes to the
Privacy Policy may be distributed through bulletins, statements, newsletters
and/or posted on the PBAS website.</span></p>

<p class=MsoNormal style='margin-bottom:11.25pt;text-align:justify;line-height:
normal;background:white'><span style='font-size:10.5pt;font-family:"Helvetica",sans-serif;
color:#444444'>&nbsp;</span></p>

<p class=MsoNormal><b><u><span style='text-decoration:none'>&nbsp;</span></u></b></p>

</div>

</body>

</html>
`,
    terms: `<html>

<head>
<meta http-equiv=Content-Type content="text/html; charset=utf-8">
<meta name=Generator content="Microsoft Word 15 (filtered)">
<style>
<!--
 /* Font Definitions */
 @font-face
	{font-family:"Cambria Math";
	panose-1:2 4 5 3 5 4 6 3 2 4;}
@font-face
	{font-family:Calibri;
	panose-1:2 15 5 2 2 2 4 3 2 4;}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{margin-top:0in;
	margin-right:0in;
	margin-bottom:8.0pt;
	margin-left:0in;
	line-height:107%;
	font-size:11.0pt;
	font-family:"Calibri",sans-serif;}
p
	{margin-right:0in;
	margin-left:0in;
	font-size:12.0pt;
	font-family:"Times New Roman",serif;}
.MsoChpDefault
	{font-family:"Calibri",sans-serif;}
.MsoPapDefault
	{margin-bottom:8.0pt;
	line-height:107%;}
@page WordSection1
	{size:8.5in 11.0in;
	margin:1.0in 1.0in 1.0in 1.0in;}
div.WordSection1
	{page:WordSection1;}
 /* List Definitions */
 ol
	{margin-bottom:0in;}
ul
	{margin-bottom:0in;}
-->
</style>

</head>

<body lang=EN-US link=blue vlink="#954F72" style='word-wrap:break-word'>

<div class=WordSection1>

<p class=MsoNormal style='line-height:normal'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>Prudent Benefits Administration
Services Inc., Benchmark Decisions Ltd., and Student Benefits Administrators
Inc. (hereinafter referred to collectively as “PBAS”, for ease of reference), would
like to express its thanks to all those who visit this Website. However, please
be aware of the following terms and conditions of using this Site. If you do
not agree with them, please exit this Site. Each time you use this Site you
indicate your acceptance of the terms and conditions set out under &quot;Terms &amp;
Conditions&quot;.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:0in'><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>In
registering for access to this Site, users agree that:</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>You have authorization from your employer or from PBAS to be
registered as a user.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>You will keep your username and password strictly confidential
and not disclose your username and password to any other person or entity.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>You will be responsible for all uses of your username and
password and all actions performed using your username and password, including
unauthorized uses and actions performed without your consent.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>4.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>You will notify PBAS immediately of the loss or unauthorized use
of your username and password.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>5.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>PBAS shall not be responsible for confirming your identity prior
to your accessing the Site.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>6.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>You will use this Site only for the purpose of (i) administering
and/or managing the Benefit plan(s) to which you have been granted access; (ii)
obtaining health and wellness information; and (iii) accessing such counselling
and other services as may be provided on or through the Site; as applicable,
and for no other or improper purpose.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>7.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>If you are a Plan Administrator or Advisor, any personal
information obtained from this Site or through any third-party website to which
you are provided access through this Site will be adequately safeguarded by you
in accordance with privacy legislation applicable where you carry on business.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>8.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>Regardless of whether you are a Plan Administrator or Advisor
you are bound by (i) the confidentiality and/or privacy provisions contained in
any applicable agreement, policy or other document governing your relationship
with PBAS, or its affiliates, with respect to the content of this Site, any
third party website to which you are provided access by PBAS through this Site;
and (ii) the terms and conditions set out under &quot;Terms &amp;
Conditions&quot;.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>9.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>You are responsible for the accuracy and completeness of the
information that you submit through the Site. To the extent that the Site
permits you access to online message/discussion boards where you may submit my
contributions for others to read, none of my contributions shall contain
anything unlawful and/or obscene.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>10.<span style='font:7.0pt "Times New Roman"'>&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>PBAS, and its contracted third-party service providers, as
applicable, have the right to monitor your use of this Site, and any
third-party website to which you are granted access through this Site, and
review information created or accessed under your username and password.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>11.<span style='font:7.0pt "Times New Roman"'>&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>PBAS has the right to restrict or cancel your access to any part
or parts of this Site, or to any part or parts of a website that PBAS may provide
you with access to through this Site, at any time, with or without notice.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>12.<span style='font:7.0pt "Times New Roman"'>&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>Your use of this Site is subject to the terms and conditions set
out in here, and any other terms and conditions that PBAS may communicate to
you. You agree to comply with such terms and conditions.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>13.<span style='font:7.0pt "Times New Roman"'>&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>If your association with your employer and/or PBAS terminates,
you agree to immediately discontinue use of your username and password.</span></p>

<p style='margin-left:.5in;text-indent:-.25in'><span style='font-size:10.5pt;
font-family:"Arial",sans-serif;color:#333333'>14.<span style='font:7.0pt "Times New Roman"'>&nbsp;
</span></span><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>Your obligations under this Agreement continue even after you
stop using this Site or you relationship with your employer or with PBAS ends.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>15.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>Your
violation of the provisions of these Terms &amp; Conditions could result in:
(a) termination of your use of this Site; (b) notification of the violation to
your employer; and (c) liability for damages for the misuse of information
provided to you through this Site or for misuse of the Site itself.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>16.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>The
contents of this Site, including the manner in which the contents are
displayed, are the sole property of PBAS or of its licensors. Except as set out
below, you are not granted any rights in or to the contents made available on
or via the Site or in or to the Site itself. All such rights remain with, and
are reserved by, PBAS or their respective owners.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>17.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>PBAS
grants you a limited license to: (i) display the contents of this Site on your
computer, or other electronic device used to access this Site; and (ii) print,
download and use the contents on this Site solely for informational purposes;
provided that the Site contents are not modified in any way and that all existing
copyright and other notices are displayed. You agree not to, or allow others
to, directly or indirectly, attempt to or actually disrupt, impair or interfere
with, alter or modify this Site or any of its contents.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>18.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>PBAS
expressly disclaims all representations, warranties or conditions, express or
implied, statutory or otherwise, including, without limitation, the warranties
and conditions of merchantable quality and fitness for a particular purpose,
non-infringement, compatibility, timeliness, security or accuracy, and any
representations, warranties or conditions that may arise from a course of
dealing or usage of trade.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>19.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>All
information provided on this Site, including these Terms &amp; Conditions, is
subject to change without notice. You should, therefore, review this &quot;Terms
&amp; Conditions&quot; page each time you visit this Site to inform yourself of
any changes. If you do not agree with any changes, please exit this Site. Your
continued use of this Website after PBAS has made any changes to this &quot;Terms
&amp; Conditions&quot; page is deemed to constitute your acceptance of such
changes.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>20.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>This Site
does not, and is not intended to provide any legal, financial, accounting,
insurance or tax advice and should not be relied upon by you for such advice.
You should secure advice from your own professional advisors. </span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>21.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>Your use
of this Site is entirely at your own risk. Neither PBAS, nor any of its
affiliated companies, nor their officers, directors, employees or agents, nor
any other person associated with the creation and/or maintenance of this Site
or its contents shall be responsible to any person for any harm, loss or damage
(including any loss of data or damage to your computer system), however caused,
that may arise from your use of the Site or its contents, or the unavailability
of the Site for your use, including, without limitation, any direct, indirect,
special, third party, or consequential damages, even if it or they have been
advised of the possibility of such harm, loss or damage. Without limiting the
foregoing, PBAS shall not be responsible for any detrimental reliance that you
may place upon this Site, or its contents. By accessing and using this Site,
you assume the risk that the information and documentation presented may not
meet your needs and requirements and that, particularly in the medical and
health/wellness areas of websites provided by PBAS and accessed through this
Site, such information and documentation may be offensive to some.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>22.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>If PBAS
provides you with any user name and password to access any secure area of this
Site, you agree to keep such user name and password strictly confidential and
not to disclose the user name and password to any other person or entity. </span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>23.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>You agree
to be liable for all uses of your user name and password, including unauthorized
use without your consent, and you acknowledge that PBAS shall not be
responsible for confirming the identity of any user. You agree to notify PBAS
immediately of the loss or unauthorized use of your user name and password.
PBAS has the right to restrict or cancel your access to any part or parts of
this Site, including any website made accessible to you through this Site,
where access is controlled by login information and/or passwords provided by
PBAS at any time, with or without notice.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>24.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>The
limitations expressed above shall apply to your use of this Site regardless of
the causes or circumstances giving rise to the claim, even if such claim is
based on breach of contract, negligence or other tort, and shall survive a
fundamental breach or failure of essential purpose of any limited remedy or
these terms and conditions. You acknowledge and agree that any claim or cause
of action you may have arising out of, or relating to, the Site must be filed
within one (1) year after such claim or cause of action arises, or it will be
permanently barred.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>25.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>PBAS, its
affiliates and its contracted service providers for the Site, or for websites
accessible through the Site, may use &quot;cookies&quot; to facilitate your
online experience or to provide you with access to the Site. A &quot;cookie&quot;
is a text file that is placed on your hard disk by a web page server. Cookies
cannot be used to run programs or to deliver viruses to your computer. Cookies
are uniquely assigned to you, and can only be read by a web server in the
domain that issued the cookie to you. One of the primary purposes of cookies is
to ensure that you are authorized to use this Site. Encrypted cookies, which
contain your insurance policy and certificate number, may be used for the
purposes of authenticating your identity and providing you with access to this
Site, or to any other website provided by PBAS through this Site. Your ability
to access this Site, or any other website provided through this Site, may be
limited should your computer not accept these encrypted cookies.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>26.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>All
information provided on this Site is used for the business purposes of PBAS.
You agree that the Internet is not a secure medium, privacy cannot be ensured
and security and/or confidentiality over the Internet are not guaranteed.
Without limiting any other disclaimer contained under &quot;Terms &amp;
Conditions&quot; and “Privacy Policy”, PBAS, shall not be responsible for any
loss or damages you may incur as a result of your communicating confidential
and/or personal information to us over the Internet or of our communicating, at
your request, confidential and/or personal information to you over the
Internet. Please read our Privacy Policy for information about our privacy
practices.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>27.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>Certain
information on this Site relating to segregated funds and underlying mutual
funds may be provided by third parties. Without limiting any other disclaimer
contained under &quot;Terms &amp; Conditions&quot;, PBAS will not be
responsible for any errors in this information, or for any loss or damages to
any person caused by reliance on this information.</span></p>

<p style='margin-top:0in;margin-right:0in;margin-bottom:7.5pt;margin-left:.5in;
text-indent:-.25in'><span style='font-size:10.5pt;font-family:"Arial",sans-serif;
color:#333333'>28.<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
style='font-size:10.5pt;font-family:"Arial",sans-serif;color:#333333'>You agree
that you will not use, or permit anyone else to use, any robot, scraper, spider
or other automated devices or means to access or use the Site for any purpose
without the prior expressed written consent of PBAS. You agree that you will
not: (i) interfere or attempt to interfere with the proper working of the Site;
(ii) bypass any measures used to prevent or restrict access to the Site; or
(iii) take any action that imposes an unreasonable or disproportionately large
load on the infrastructure used to run and maintain the Site.</span></p>

</div>

</body>

</html>
`,
  }),
};
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
